import html2pdf from 'html2pdf.js/dist/html2pdf.min.js';
import ReactDOMServer from 'react-dom/server';

export const downloadCouponsPdf = ({ ref, component, id }) => {
  let element;
  if (component) {
    // Render component to static markup and create a container for it
    const container = document.createElement('div');
    container.innerHTML = ReactDOMServer.renderToStaticMarkup(component);
    element = container;
  } else if (ref) {
    element = ref.current;
  } else if (id) {
    element = document.getElementById(id);
  }

  if (element) {
    // Use html2pdf to generate the PDF
    const options = {
      margin: 0.2,
      filename: 'document.pdf',
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
    };

    html2pdf().from(element).set(options).save();
  } else {
    console.error('No valid element to generate PDF from.');
  }
};
